<div class="message-area">
  <img src="assets/images/404.png">
  <h2 class="message"><b>お探しのページは見つかりませんでした。</b></h2>
</div>
